import { createSlice } from '@reduxjs/toolkit';
import { dummyDecks } from '../../data/dummyDecks';

const initialState = {
  userDecks: dummyDecks.filter(deck => deck.creatorId === 'user1'),
  publicDecks: dummyDecks.filter(deck => deck.isPublic),
  currentDeck: null,
  filters: {
    ownedCardsOnly: false,
    types: [],
    hasCard: null
  }
};

const deckSlice = createSlice({
  name: 'deck',
  initialState,
  reducers: {
    createDeck: (state, action) => {
      const newDeck = {
        id: Date.now().toString(),
        name: action.payload.name,
        description: action.payload.description,
        cards: action.payload.cards || [],
        type: action.payload.type || 'Standard',
        isPublic: action.payload.isPublic || false,
        creatorId: action.payload.creatorId,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      state.userDecks.push(newDeck);
      if (newDeck.isPublic) {
        state.publicDecks.push(newDeck);
      }
    },
    updateDeck: (state, action) => {
      const { id, ...updates } = action.payload;
      const deckIndex = state.userDecks.findIndex(deck => deck.id === id);
      if (deckIndex !== -1) {
        state.userDecks[deckIndex] = {
          ...state.userDecks[deckIndex],
          ...updates,
          updatedAt: new Date().toISOString()
        };
        
        // Update public deck if exists
        const publicDeckIndex = state.publicDecks.findIndex(deck => deck.id === id);
        if (publicDeckIndex !== -1) {
          state.publicDecks[publicDeckIndex] = state.userDecks[deckIndex];
        }
      }
    },
    deleteDeck: (state, action) => {
      state.userDecks = state.userDecks.filter(deck => deck.id !== action.payload);
      state.publicDecks = state.publicDecks.filter(deck => deck.id !== action.payload);
    },
    setCurrentDeck: (state, action) => {
      state.currentDeck = action.payload;
    },
    addCardToDeck: (state, action) => {
      const { deckId, card } = action.payload;
      const deckIndex = state.userDecks.findIndex(deck => deck.id === deckId);
      if (deckIndex !== -1) {
        state.userDecks[deckIndex].cards.push(card);
        state.userDecks[deckIndex].updatedAt = new Date().toISOString();
        
        // Update public deck if exists
        const publicDeckIndex = state.publicDecks.findIndex(deck => deck.id === deckId);
        if (publicDeckIndex !== -1) {
          state.publicDecks[publicDeckIndex] = state.userDecks[deckIndex];
        }
      }
    },
    removeCardFromDeck: (state, action) => {
      const { deckId, cardId } = action.payload;
      const deckIndex = state.userDecks.findIndex(deck => deck.id === deckId);
      if (deckIndex !== -1) {
        state.userDecks[deckIndex].cards = state.userDecks[deckIndex].cards.filter(
          card => card.id !== cardId
        );
        state.userDecks[deckIndex].updatedAt = new Date().toISOString();
        
        // Update public deck if exists
        const publicDeckIndex = state.publicDecks.findIndex(deck => deck.id === deckId);
        if (publicDeckIndex !== -1) {
          state.publicDecks[publicDeckIndex] = state.userDecks[deckIndex];
        }
      }
    },
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload
      };
    }
  }
});

export const {
  createDeck,
  updateDeck,
  deleteDeck,
  setCurrentDeck,
  addCardToDeck,
  removeCardFromDeck,
  setFilters
} = deckSlice.actions;

export default deckSlice.reducer; 